/**
 * @generated SignedSource<<93470109b1502fb0ef186424fc3c66ef>>
 * @relayHash 2928057d03b4f5d5a1a268a9759b926b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492

import type { ConcreteRequest } from 'relay-runtime';
export type useFetchSuggestionCountQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type useFetchSuggestionCountQuery$data = {
  readonly confluence_remoteObjectSuggestionCount: number | null | undefined;
};
export type useFetchSuggestionCountQuery = {
  response: useFetchSuggestionCountQuery$data;
  variables: useFetchSuggestionCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "kind": "ScalarField",
    "name": "confluence_remoteObjectSuggestionCount"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFetchSuggestionCountQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFetchSuggestionCountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2928057d03b4f5d5a1a268a9759b926b",
    "id": "e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492",
    "metadata": {},
    "name": "useFetchSuggestionCountQuery",
    "operationKind": "query",
    "text": "query useFetchSuggestionCountQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}"
  }
};
})();

(node as any).hash = "b167569d29d494154affeddaea33f5a3";

export default node;
